import tab from './tab'
import auth  from './auth'
import modal from './modal'
import cache from './cache'
import download from './download'

export default {
  install(Vue) {
    // 权限对象
    Vue.prototype.$auth = auth
    // 模态框对象
    Vue.prototype.$modal = modal
    // 缓存对象
    Vue.prototype.$cache = cache
    // 页签操作
    Vue.prototype.$tab = tab
    // 下载文件
    Vue.prototype.$download = download
  }
}
